import React from 'react';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import './admin.css';

const EventManagement = () => {
    const navigate = useNavigate();
    const location = useLocation();

    React.useEffect(() => {
        // Redirect to functions tab by default
        if (location.pathname === '/admin/events') {
            navigate('/admin/events/functions');
        }
    }, [navigate, location]);

    const isActiveTab = (path) => {
        return location.pathname === path;
    };

    return (
        <div className="event-management">
            <div className="event-tabs">
                <Link 
                    to="/admin/events/functions"
                    className={`tab ${isActiveTab('/admin/events/functions') ? 'active' : ''}`}
                >
                    Functions
                </Link>
                <Link 
                    to="/admin/events/subfunctions"
                    className={`tab ${isActiveTab('/admin/events/subfunctions') ? 'active' : ''}`}
                >
                    Sub-Functions
                </Link>
                <Link 
                    to="/admin/events/items"
                    className={`tab ${isActiveTab('/admin/events/items') ? 'active' : ''}`}
                >
                    Items
                </Link>
            </div>
            <div className="event-content">
                <Outlet />
            </div>
        </div>
    );
};

export default EventManagement;